<template>
  <div class="case" @click="$router.push(`/detail/${item.id}?type=user`)">
    <div class="top">
      <div class="l">
        {{ item.name }}
        <a
          class="phone"
          :href="`tel:${item.mobile}`"
          @click.stop
          v-if="item.mobile"
          >- {{ item.mobile | dash }} <van-icon name="phone"
        /></a>
      </div>
    </div>
    <div class="tag" v-if="item.level" :class="[currentStyle]">
      {{ item.level | enumMessage(AllEnums.CRM_CUSTOMER_LEVEL) }}
    </div>
    <div class="content">
      <div class="attrs">
        <div>联系时间: {{ item.contactNextTime | dateFormat("YYYY-MM-DD") }}</div>
        <div>跟进内容：{{ item.contactLastContent | dash }}</div>
      </div>
      <div class="status" v-if="item.dealStatus">已成交</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    // 管理员岗位：可见，但不能操作
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
    isExpire: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    currentStyle() {
      let color = {
        1: "danger",
        2: "warning",
        3: "info",
      };
      return color[this.item.level] || "danger";
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.danger {
  background-color: #ff4848;
}
.warning {
  background-color: #fa9540;
}
.info {
  background-color: #ababab;
}
.case {
  background: #ffffff;
  border-radius: 4px;
  position: relative;
  user-select: text;
  position: relative;

  &::before {
    content: " ";
    position: absolute;
    left: 0px;
    top: 12px;
    width: 4px;
    height: 32px;
    background: #3c86ff;
    border-radius: 0 100px 100px 0px;
  }

  .top {
    padding: 18px 17px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    letter-spacing: 0;
    color: #2b2e32;

    .l {
      font-weight: bold;
    }

    .r {
      font-weight: 500;
    }

    .phone {
      color: #3c86ff;
    }
  }

  .tag {
    position: absolute;
    right: 0px;
    top: 11px;
    padding: 8px 10px 8px 16px;
    border-radius: 100px 0 0 100px;
    font-size: 12px;
    color: #fff;
    letter-spacing: 0;
  }

  .content {
    position: relative;
    display: flex;

    .attrs {
      flex: 1;
      padding: 0px 16px 18px 17px;

      div {
        color: #787b84;
        font-size: 12px;
        line-height: 1.8em;
        word-break: break-all;
      }
    }

    .status {
      position: absolute;
      right: 0px;
      bottom: 10px;
      padding: 8px 10px 8px 16px;
      background: #7bd17c;
      border-radius: 100px 0 0 100px;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;

      &.warning {
        background: #fa9540;
      }
    }
  }
}
</style>
